// @flow
import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
  CHANGE_SIDEBAR_THEME_IMAGE,
  CHANGE_PRELOADER,
  TOGGLE_LEFTMENU,
  SHOW_SIDEBAR,
  CHANGE_LAYOUT_MODE,
  CHANGE_FONT_SCALE,
  CHANGE_FONT_FAMILY,
  CHANGE_FONT_COLOR,
  CHANGE_UI_THEME,
  HYDRATE_HEADER_SETTINGS,
} from "./actionTypes";

//constants
import {
  layoutTypes,
  layoutModeTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  fontScaleTypes,
  fontFamilyTypes,
  fontColorTypes,
  uiThemeTypes,
  FONT_SCALE_STORAGE_KEY,
  FONT_FAMILY_STORAGE_KEY,
  FONT_COLOR_STORAGE_KEY,
  UI_THEME_STORAGE_KEY,
} from "../../constants/layout";

const readStoredFontScale = () => {
  try {
    const value = localStorage.getItem(FONT_SCALE_STORAGE_KEY);
    if (
      value === fontScaleTypes.SMALL ||
      value === fontScaleTypes.CURRENT ||
      value === fontScaleTypes.LARGE
    ) {
      return value;
    }
  } catch (_error) {}
  return fontScaleTypes.CURRENT;
};

const readStoredUiTheme = () => {
  try {
    const value = localStorage.getItem(UI_THEME_STORAGE_KEY);
    if (
      value === uiThemeTypes.CURRENT ||
      value === uiThemeTypes.MODERN ||
      value === uiThemeTypes.DARK
    ) {
      return value;
    }
  } catch (_error) {}
  return uiThemeTypes.CURRENT;
};

const readStoredFontFamily = () => {
  try {
    const value = localStorage.getItem(FONT_FAMILY_STORAGE_KEY);
    if (
      value === fontFamilyTypes.POPPINS ||
      value === fontFamilyTypes.ROBOTO ||
      value === fontFamilyTypes.OPEN_SANS
    ) {
      return value;
    }
  } catch (_error) {}
  return fontFamilyTypes.POPPINS;
};

const readStoredFontColor = () => {
  try {
    const value = localStorage.getItem(FONT_COLOR_STORAGE_KEY);
    if (
      value === fontColorTypes.CURRENT ||
      value === fontColorTypes.CHARCOAL ||
      value === fontColorTypes.SOFT_NAVY ||
      value === fontColorTypes.RED ||
      value === fontColorTypes.PRIMARY ||
      value === fontColorTypes.DEEP_SAPPHIRE ||
      value === fontColorTypes.DEEP_MAROON ||
      value === fontColorTypes.DEEP_BLACK
    ) {
      return value;
    }
  } catch (_error) {}
  return fontColorTypes.CURRENT;
};

const INIT_STATE = {
  layoutType: layoutTypes.VERTICAL,
  layoutModeType: layoutModeTypes.LIGHT,
  layoutWidth: layoutWidthTypes.FLUID,
  leftSideBarTheme: leftSideBarThemeTypes.DARK,
  leftSideBarThemeImage: leftBarThemeImageTypes.NONE,
  leftSideBarType: leftSidebarTypes.DEFAULT,
  topbarTheme: topBarThemeTypes.LIGHT,
  fontScale: readStoredFontScale(),
  fontFamily: readStoredFontFamily(),
  fontColor: readStoredFontColor(),
  uiTheme: readStoredUiTheme(),
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}
const Layout = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LAYOUT:
      return {
        ...state,
        layoutType: action.payload,
      }
    case CHANGE_PRELOADER:
      return {
        ...state,
        isPreloader: action.payload,
      }

    case CHANGE_LAYOUT_MODE:
      return {
        ...state,
        layoutModeType: action.payload,
      }

    case CHANGE_LAYOUT_WIDTH:
      return {
        ...state,
        layoutWidth: action.payload,
      }
    case CHANGE_SIDEBAR_THEME:
      return {
        ...state,
        leftSideBarTheme: action.payload,
      }
    case CHANGE_SIDEBAR_THEME_IMAGE:
      return {
        ...state,
        leftSideBarThemeImage: action.payload,
      }
    case CHANGE_SIDEBAR_TYPE:
      return {
        ...state,
        leftSideBarType: action.payload.sidebarType,
      }
    case CHANGE_TOPBAR_THEME:
      return {
        ...state,
        topbarTheme: action.payload,
      }
    case SHOW_RIGHT_SIDEBAR:
      return {
        ...state,
        showRightSidebar: action.payload,
      }
    case SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: action.payload,
      }
    case TOGGLE_LEFTMENU:
      return {
        ...state,
        leftMenu: action.payload,
      }

    case CHANGE_FONT_SCALE:
      return {
        ...state,
        fontScale: action.payload,
      }

    case CHANGE_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.payload,
      }

    case CHANGE_FONT_COLOR:
      return {
        ...state,
        fontColor: action.payload,
      }

    case CHANGE_UI_THEME:
      return {
        ...state,
        uiTheme: action.payload,
      }

    case HYDRATE_HEADER_SETTINGS:
      return {
        ...state,
        fontScale: action.payload?.fontScale || state.fontScale,
        fontFamily: action.payload?.fontFamily || state.fontFamily,
        fontColor: action.payload?.fontColor || state.fontColor,
        uiTheme: action.payload?.uiTheme || state.uiTheme,
      }

    default:
      return state
  }
}

export default Layout
